<template>
	<div>
		<!-- <pre>{{requestData}}</pre> -->

		<table
			class="table"
			:class="{
				'table-striped': tableStriped,
				'table-hover': tableHover,
			}"
		>
			<sThead
				:labels="labels"
				:actions="actions != null"
				:noOrder="noOrder"
				v-model="header.order"
				@updateTable="updateTable"
			/>

			<template v-if="!is_load">
				<sTbody
					:labels="labels"
					:requestData="requestData"
					:actions="actions"
					:tags="tags"
					:functions="functions"
					:lineStatus="lineStatus"
					:actionsTmp="actionsTmp"
					@customAction="customAction"
				/>

				<!-- Mensagens -->
				<tbodyMsgErro
					:colspan="
						actions != null ? labels.length + 1 : labels.length
					"
					:ajax="requestData"
					:msgError="msgError"
				/>
			</template>
			<template v-else>
				<tbody>
					<tr class="warning">
						<th :colspan="labels.length + 1" class="text-center">
							<i class="fa fa-spin fa-spinner"></i>
							Carregando...
						</th>
					</tr>
				</tbody>
			</template>
		</table>
		<sPager
			v-if="noPager == true"
			:registros="realTotalRegistros"
			:qnt="header.pager.qnt"
			v-model="header.pager.page"
			@uQnt="(val) => (header.pager.qnt = val)"
			@updateTable="updateTable"
		/>
	</div>
</template>
<script>
	import WBS from 'js/http';
	import is_json from 'js/is_json';
	import toastr from 'toastr';
	import swal from 'sweetalert';
	import clone from 'js/clone';

	//Componentes da table
	import sPager from './paginator.vue';
	import sThead from './thead.vue';
	import tbodyMsgErro from './tb-msg-error.vue';
	import sTbody from './tbody.vue';

	import { chunk, orderBy } from 'lodash';

	export default {
		name: 'AppTableComponent',
		components: { sPager, sThead, tbodyMsgErro, sTbody },
		data() {
			return {
				is_load: false,
				msgError: null,
				pre_requestData: null,
				total_registros: 0,
				header: {
					pager: {
						page: 0,
						qnt: 50,
					},
					order: [],
					filter: null,
				},
			};
		},
		props: {
			noPager: {
				default: true,
			},
			noOrder: {
				default: true,
			},
			actionsTmp: {
				default: null,
				type: Object,
			},
			actionRead: {
				type: String,
				required: true,
			},
			tableStriped: {
				default: true,
			},
			tableHover: {
				default: true,
			},
			actionDeleteAll: {
				type: String,
				default: '',
			},

			actionDelete: {
				type: String,
				default: '',
			},

			anexx: {
				type: String,
				default: '',
			},

			labels: {
				type: Array,
				default: null,
			},
			actions: {
				default: null,
			},
			tags: {
				type: Array,
				default: null,
			},
			functions: {
				type: Array,
				default: null,
			},
			block: {
				default: false,
			},
			debug: {
				default: false,
			},
			lineStatus: {
				default: undefined,
			},
			compData: {
				default: null,
			},
			filterFx: {
				default: null,
			},
			preRequestData: {
				default: () => [],
			},
			totalRegistros: {
				default: 0,
			},
		},
		provide() {
			return {
				customAction: this.customAction,
				fxdelete: this.fxdelete,
			};
		},
		computed: {
			requestData() {
				if (this.actionRead != 'inject') {
					if (this.filterFx == null)
						return this.pre_requestData == null
							? []
							: this.pre_requestData;

					if (typeof this.filterFx != 'function')
						return this.pre_requestData == null
							? []
							: this.pre_requestData;

					try {
						var t = this.filterFx(this);
						return Array.isArray(t) ? this.chunk_order(t) : [];
					} catch (t) {
						return this.pre_requestData == null
							? []
							: this.pre_requestData;
					}
					return [];
				} else {
					return this.preRequestData;
				}
			},
			realTotalRegistros() {
				if (this.actionRead != 'inject') {
					return this.total_registros;
				} else {
					return this.totalRegistros;
				}
			},
		},
		methods: {
			chunk_order(payload) {
				let colls = [];
				let sent = [];
				this.header.order.forEach((item) => {
					colls.push(item.data);
					sent.push(item.sent.toLowerCase());
				});
				payload = orderBy(payload, colls, sent);
				this.total_registros = payload.length;
				return chunk(payload, this.header.pager.qnt)[
					this.header.pager.page
				];
				return [];
			},
			customAction(payload) {
				if (payload.action == 'delete') this.fxdelete(payload.data);
				else if (payload.action == 'deleteAll')
					this.fxdeleteAll(payload.data);
				else this.$emit(payload.action, payload.data);
			},
			fxdeleteAll(payload) {
				if (this.actionDeleteAll == '') this.$emit('delete', payload);
				else {
					swal({
						title: 'Atenção',
						text: 'Tem certeza que quer apagar este registro? \n Não será possível acessá-lo novamente!',
						icon: 'warning',
						buttons: ['Cancelar', 'Sim, apagar registro!'],
						dangerMode: true,
					}).then((value) => {
						if (value)
							WBS.send(this.actionDeleteAll, payload, (resp) => {
								if (resp.status == 'success') {
									toastr.success(
										'Registro excluído com sucesso!'
									);
									this.request_solicitation();
								} else {
									toastr.error(resp.msgs[0]);
									console.log(resp);
								}
							});
					});
				}
			},

			fxdelete(payload) {
				if (this.actionDelete == '') this.$emit('delete', payload);
				else {
					swal({
						title: 'Atenção',
						text: 'Tem certeza que quer apagar este registro? \n Não será possível acessá-lo novamente!',
						icon: 'warning',
						buttons: ['Cancelar', 'Sim, apagar registro!'],
						dangerMode: true,
					}).then((value) => {
						if (value)
							WBS.send(this.actionDelete, payload, (resp) => {
								if (resp.status == 'success') {
									toastr.success(
										'Registro excluído com sucesso!'
									);
									this.request_solicitation();
								} else {
									toastr.error(resp.msgs[0]);
									console.log(resp);
								}
							});
					});
				}
			},
			setFilter(filter) {
				this.header.filter = filter;
			},
			setData(data) {
				// console.log(data)
				this.pre_requestData = data.table;
				this.total_registros = data.num_rows;
			},
			updateTable() {
				this.setData({ table: null, num_rows: 0 });
				this.request_solicitation();
			},
			request_solicitation() {
				if (this.actionRead != 'inject') {
					let sData = clone(this.header);
					if (this.compData != null) sData.cData = this.compData;
					this.is_load = true;
					WBS.send(
						this.actionRead,
						sData,
						(resp) => {
							this.is_load = false;
							if (is_json(resp)) {
								resp = JSON.parse(resp);
								if (resp.status == 'error') {
									this.msgError = resp.msgs;
								} else if (resp.status == 'success') {
									if (this.debug !== false)
										console.log(resp.data.table);
									this.setData(resp.data);
									setTimeout((e) => {
										this.$emit('updated');
									}, 1000);
								}
							} else {
								toastr.error('A resposta não é JSON.');
								console.log(resp);
							}
						},
						'html'
					);
				} else {
					this.setData({
						table: this.preRequestData,
						num_rows: this.totalRegistros,
					});
				}
			},
			getRow(val, xId = 'cod') {
				return this.requestData.find((item) => item[xId] == val);
			},
		},
		mounted() {
			if (
				this.block === false ||
				(this.block !== false &&
					this.header.filter != null &&
					this.header.filter != '')
			) {
				this.request_solicitation();
			}
		},
	};
</script>
<style scoped>
	thead tr th {
		cursor: pointer;
	}
</style>



// WEBPACK FOOTER //
// src/app-components/accordion-grid/index.vue